<template>
    <div class="" style="height: 100vh;width: 100vw;">
        <div class="" id="fusion5" style="height: 100vh;width: 100%;"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import world from '../assets/echarts/world.js'
export default {
    props: {
        rabbitData: {
            type: Object,
            default: () => {
                return {

                }
            }
        },
    },
    mounted() {
        // this.$request('center/stanCulture/middleWindowCultivation?type=1&farmId=' + this.rabbitData.id, {}).then(res => {
        this.inits()
        // })

    },
    methods: {
        inits() {
            let myChart = echarts.init(document.getElementById('fusion5'));
            var option = {
                geo: {
                    type: 'map',
                    map: 'world',
                    roam: true,
                    center: [103.73460880846545, 36.56185462191848],
                    label: {
                        emphasis: {
                            show: true
                        }
                    },
                    itemStyle: {
                        normal: {
                            areaColor: '#e0e6ef', //区域颜色
                            borderColor: '#ffffff' //区域划分边框颜色
                        },
                        emphasis: {
                            areaColor: '#e0e6ef' //鼠标Havor颜色
                        }
                    }
                },
                animation: true, // 确保这里启用了动画
                animationDuration: 3000, // 设置动画持续时间
                animationEasing: 'cubicOut', // 设置动画缓动函数
                toolbox: {
                    show: true,
                    feature: {
                        saveAsImage: {
                            show: true,
                            excludeComponents: ['toolbox'],
                            pixelRatio: 2
                        }
                    }
                },
                backgroundColor: '#EEF0F1',
            };
            myChart.setOption(option);
            // 点击事件 - 平滑放大
            myChart.on('click', (params) => {
                console.log(params);

                // 方法1：使用geoRoam
                // myChart.dispatchAction({
                //     type: 'geoRoam',
                //     name: params.name,
                //     animation: {
                //         duration: 1500,
                //         easing: 'cubicInOut'
                //     }
                // });

                // const mapModel = myChart.getModel().getComponent('geo');
                // const coordSys = mapModel.coordinateSystem;

                // const region = coordSys.getRegion(params.name);
                // console.log(region);

                // if (region) {
                //     // const center = coordSys.dataToPoint([region.center.lng, region.center.lat]);
                //     // const viewRect = coordSys.getViewRect();
                //     // const viewWidth = viewRect.width;
                //     // const viewHeight = viewRect.height;

                //     // // 计算合适的缩放级别
                //     // const zoom = Math.min(
                //     //     viewWidth / Math.abs(region.rect.width),
                //     //     viewHeight / Math.abs(region.rect.height)
                //     // ) * 0.8;

                //     myChart.dispatchAction({
                //         type: 'mapRoam',
                //         center: [region[0], region[1]],
                //         zoom: 12,
                //         animation: {
                //             duration: 1500,
                //             easing: 'cubicInOut'
                //         }
                //     });
                // }

                // const mapModel = myChart.getModel().getComponent('series');
                // const coordSys = mapModel.coordinateSystem;
                // const region = coordSys.getGeoCoord(params.name);
                // console.log(region);
                // if (region) {
                //     // const center = coordSys.dataToPoint([region.center.lng, region.center.lat]);
                //     // const viewRect = coordSys._viewRect;
                //     // const viewWidth = viewRect.width;
                //     // const viewHeight = viewRect.height;
                //     // 计算合适的缩放级别
                //     const zoom =20;
                //     myChart.dispatchAction({
                //         type: 'mapRoam',
                //         center: [region[0], region[1]],
                //         zoom: zoom,
                //         animation: {
                //             duration: 1500,
                //             easing: 'cubicInOut'
                //         }
                //     });
                // }


                // 直接从图表实例获取坐标系
                const mapModel = myChart.getModel().getComponent('geo');

                console.log(mapModel);

                const coordSys = mapModel.coordinateSystem;

                if (coordSys) {
                    const region = coordSys.getRegion(params.name);
                    console.log(region);

                    if (region) {
                        // myChart.dispatchAction({
                        //     type: 'mapRoam', // 对于地图类型
                        //     zoom: 5, // 目标缩放级别
                        //     center: [103.73460880846545, 36.56185462191848],
                        //     animation: {
                        //         duration: 2000, // 动画持续时间
                        //         easing: 'cubicInOut' // 缓动效果
                        //     }
                        // });
                        myChart.setOption({
                            geo: {
                                center: [103.73460880846545, 36.56185462191848],
                                zoom: 5,
                                // roam: true,
                            }
                        }, {
                            animation: {
                                duration: 3000,
                                easing: 'cubicInOut'
                            }
                        });
                    }
                }
            });
        }
    }
}
</script>

<style></style>